import React, { useRef } from "react";
import { gsap, useGSAP, SplitText, EASE } from "../../lib/gsap";

/**
 * Editorial line reveal. SplitText's own mask wrappers do the clipping, and
 * autoSplit re-measures after font load / resize so line breaks never desync.
 * SplitText writes an aria-label, so screen readers still read one sentence.
 */
const SplitLines = ({
  children,
  as: Tag = "p",
  className = "",
  delay = 0,
  stagger = 0.09,
  duration = 0.95,
  start = "top 85%",
  play = true,
}) => {
  const scope = useRef(null);

  useGSAP(
    () => {
      if (!play) return undefined;
      const el = scope.current;
      const mm = gsap.matchMedia();

      mm.add("(prefers-reduced-motion: reduce)", () => {
        gsap.from(el, {
          opacity: 0,
          duration: 0.4,
          delay,
          scrollTrigger: { trigger: el, start, once: true },
        });
      });

      mm.add("(prefers-reduced-motion: no-preference)", () => {
        const split = SplitText.create(el, {
          type: "lines",
          mask: "lines",
          linesClass: "split-line",
          autoSplit: true,
          onSplit: (self) =>
            gsap.from(self.lines, {
              yPercent: 108,
              duration,
              ease: EASE.out,
              stagger,
              delay,
              scrollTrigger: { trigger: el, start, once: true },
            }),
        });

        return () => split.revert();
      });

      return () => mm.revert();
    },
    { scope, dependencies: [play] }
  );

  return (
    <Tag ref={scope} className={className}>
      {children}
    </Tag>
  );
};

export default SplitLines;
